const seychelles = {
  "title": "Seychelles",
  "version": "1.1.2",
  "type": "FeatureCollection",
  "copyright": "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth",
  "copyrightShort": "Natural Earth",
  "copyrightUrl": "http://www.naturalearthdata.com",
  "crs": {
    "type": "name",
    "properties": {
      "name": "urn:ogc:def:crs:EPSG:32740"
    }
  },
  "hc-transform": {
    "default": {
      "crs": "+proj=utm +zone=40 +south +datum=WGS84 +units=m +no_defs",
      "scale": 0.00625011285224,
      "jsonres": 15.5,
      "jsonmarginX": -999,
      "jsonmarginY": 9851.0,
      "xoffset": 302656.191967,
      "yoffset": 9580847.07983
    }
  },
  "features": [{
    "type": "Feature",
    "id": "SC.6700",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.73,
      "hc-middle-y": 0.68,
      "hc-key": "sc-6700",
      "hc-a2": "BS",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549888",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Baie Sainte Anne",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.76",
      "woe-name": "Baie Ste. Anne",
      "latitude": "-4.32918",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4501, 4518],
            [4497, 4482],
            [4366, 4527],
            [4273, 4611],
            [4305, 4649],
            [4381, 4649],
            [4557, 4638],
            [4605, 4634],
            [4589, 4582],
            [4489, 4582],
            [4501, 4518]
          ]
        ],
        [
          [
            [3958, 4461],
            [4037, 4489],
            [4110, 4502],
            [4191, 4506],
            [4344, 4366],
            [4489, 4307],
            [4645, 4279],
            [4729, 4176],
            [4837, 4224],
            [4973, 4204],
            [5079, 4075],
            [4906, 4067],
            [4877, 3978],
            [4875, 3864],
            [4655, 3985],
            [4585, 4090],
            [3958, 4461]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6707",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.76,
      "hc-middle-y": 0.96,
      "hc-key": "sc-6707",
      "hc-a2": "GP",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549889",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Grand'Anse Praslin",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.7435",
      "woe-name": "Grand Anse Praslin",
      "latitude": "-4.34469",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [3618, 3828],
            [3586, 3828],
            [3538, 3871],
            [3574, 3899],
            [3594, 3879],
            [3618, 3828]
          ]
        ],
        [
          [
            [3774, 4035],
            [3718, 4027],
            [3714, 4075],
            [3746, 4099],
            [3782, 4087],
            [3774, 4035]
          ]
        ],
        [
          [
            [3876, 5342],
            [3840, 5314],
            [3760, 5321],
            [3704, 5333],
            [3716, 5361],
            [3784, 5365],
            [3824, 5357],
            [3876, 5342]
          ]
        ],
        [
          [
            [4875, 3864],
            [4780, 3776],
            [4647, 3779],
            [4496, 3842],
            [4395, 3946],
            [4333, 4079],
            [4188, 4103],
            [4058, 4119],
            [3978, 4199],
            [3969, 4277],
            [3898, 4439],
            [3958, 4461],
            [4585, 4090],
            [4655, 3985],
            [4875, 3864]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6708",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.03,
      "hc-middle-y": 0.85,
      "hc-key": "sc-6708",
      "hc-a2": "LD",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "-99",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "La Digue and Inner Islands",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.8393",
      "woe-name": null,
      "latitude": "-4.35949",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [6837, 1288],
            [6780, 1269],
            [6718, 1275],
            [6653, 1339],
            [6648, 1380],
            [6683, 1407],
            [6729, 1420],
            [6775, 1407],
            [6829, 1337],
            [6837, 1288]
          ]
        ],
        [
          [
            [-581, 2248],
            [-777, 2205],
            [-928, 2382],
            [-999, 2639],
            [-957, 2838],
            [-778, 2780],
            [-585, 2645],
            [-485, 2462],
            [-581, 2248]
          ]
        ],
        [
          [
            [5694, 3608],
            [5666, 3516],
            [5590, 3536],
            [5494, 3632],
            [5470, 3763],
            [5525, 3894],
            [5561, 4002],
            [5693, 3947],
            [5765, 3811],
            [5833, 3708],
            [5761, 3672],
            [5694, 3608]
          ]
        ],
        [
          [
            [6549, 3944],
            [6537, 3872],
            [6497, 3892],
            [6485, 3972],
            [6509, 4039],
            [6561, 4008],
            [6549, 3944]
          ]
        ],
        [
          [
            [6129, 4011],
            [6065, 3995],
            [6009, 4055],
            [5937, 4154],
            [5957, 4218],
            [6009, 4206],
            [6113, 4094],
            [6129, 4011]
          ]
        ],
        [
          [
            [6012, 4445],
            [5972, 4441],
            [5932, 4524],
            [5932, 4584],
            [5968, 4580],
            [5980, 4512],
            [6012, 4445]
          ]
        ],
        [
          [
            [3701, 9851],
            [3767, 9630],
            [3689, 9630],
            [3617, 9743],
            [3701, 9851]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6711",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.82,
      "hc-middle-y": 0.13,
      "hc-key": "sc-6711",
      "hc-a2": "MF",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549882",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Mont Fleuri",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4633",
      "woe-name": "Mont Fleuri",
      "latitude": "-4.63449",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [1970, 882],
            [1996, 863],
            [2017, 874],
            [2043, 865],
            [2073, 788],
            [2062, 759],
            [2028, 756],
            [1984, 771],
            [1953, 801],
            [1913, 816],
            [1910, 863],
            [1932, 883],
            [1970, 882]
          ]
        ],
        [
          [
            [2137, 892],
            [2119, 867],
            [2090, 879],
            [2054, 903],
            [2035, 931],
            [2045, 954],
            [2060, 951],
            [2087, 928],
            [2123, 918],
            [2137, 892]
          ]
        ],
        [
          [
            [2040, 1201],
            [2090, 1190],
            [2134, 1190],
            [2154, 1178],
            [2134, 1134],
            [2099, 1087],
            [2029, 1059],
            [1985, 1029],
            [1965, 1026],
            [1960, 1057],
            [1971, 1113],
            [1964, 1151],
            [1977, 1174],
            [1993, 1187],
            [2040, 1201]
          ]
        ],
        [
          [
            [1618, 678],
            [1519, 838],
            [1575, 861],
            [1575, 908],
            [1617, 910],
            [1696, 809],
            [1646, 734],
            [1618, 678]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6714",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.70,
      "hc-middle-y": 0.62,
      "hc-key": "sc-6714",
      "hc-a2": "PG",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549876",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Port Glaud",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4262",
      "woe-name": "Port Glaud",
      "latitude": "-4.65351",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [984, 325],
            [970, 321],
            [927, 370],
            [899, 395],
            [901, 417],
            [887, 434],
            [895, 448],
            [915, 446],
            [938, 436],
            [978, 413],
            [999, 378],
            [990, 344],
            [984, 325]
          ]
        ],
        [
          [
            [644, 469],
            [635, 453],
            [601, 467],
            [548, 474],
            [517, 498],
            [501, 523],
            [525, 545],
            [562, 531],
            [609, 496],
            [644, 469]
          ]
        ],
        [
          [
            [1562, 565],
            [1519, 485],
            [1430, 471],
            [1425, 405],
            [1463, 391],
            [1452, 348],
            [1306, 363],
            [1120, 473],
            [1024, 530],
            [944, 533],
            [866, 561],
            [871, 604],
            [926, 614],
            [899, 647],
            [812, 674],
            [707, 650],
            [616, 678],
            [556, 722],
            [573, 760],
            [655, 752],
            [685, 775],
            [653, 830],
            [715, 889],
            [1019, 738],
            [1136, 790],
            [1117, 870],
            [1263, 926],
            [1301, 856],
            [1368, 795],
            [1410, 640],
            [1562, 565]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6702",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.30,
      "hc-key": "sc-6702",
      "hc-a2": "BA",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549883",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Bel Air",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4483",
      "woe-name": "Bel Air",
      "latitude": "-4.63198",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1557, 988],
          [1589, 941],
          [1539, 925],
          [1534, 906],
          [1575, 908],
          [1575, 861],
          [1519, 838],
          [1618, 678],
          [1562, 565],
          [1410, 640],
          [1368, 795],
          [1301, 856],
          [1433, 960],
          [1557, 988]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6703",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.44,
      "hc-middle-y": 0.19,
      "hc-key": "sc-6703",
      "hc-a2": "BO",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549890",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Bel Ombre",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4092",
      "woe-name": "Belombre",
      "latitude": "-4.62448",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [715, 889],
          [800, 971],
          [867, 999],
          [998, 1009],
          [1079, 1045],
          [1108, 1011],
          [1202, 1044],
          [1263, 926],
          [1117, 870],
          [1136, 790],
          [1019, 738],
          [715, 889]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6704",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.87,
      "hc-middle-y": 0.43,
      "hc-key": "sc-6704",
      "hc-a2": "CA",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549871",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Cascade",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4988",
      "woe-name": "Cascade",
      "latitude": "-4.66702",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1914, 632],
          [1975, 590],
          [2147, 475],
          [2068, 355],
          [2043, 317],
          [2003, 331],
          [1949, 349],
          [1815, 516],
          [1887, 556],
          [1914, 632]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6705",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.21,
      "hc-middle-y": 0.14,
      "hc-key": "sc-6705",
      "hc-a2": "GL",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549878",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Glacis",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4433",
      "woe-name": "Glacis",
      "latitude": "-4.56942",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1275, 1322],
          [1293, 1401],
          [1285, 1583],
          [1360, 1605],
          [1434, 1599],
          [1513, 1587],
          [1610, 1489],
          [1560, 1435],
          [1428, 1458],
          [1362, 1322],
          [1275, 1322]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6706",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.54,
      "hc-middle-y": 0.44,
      "hc-key": "sc-6706",
      "hc-a2": "GR",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549875",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Grand'Anse",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4738",
      "woe-name": "Grand Anse Mahe",
      "latitude": "-4.68654",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1815, 516],
          [1949, 349],
          [1911, 236],
          [1794, 142],
          [1765, 43],
          [1659, 53],
          [1553, 208],
          [1452, 348],
          [1463, 391],
          [1425, 405],
          [1430, 471],
          [1519, 485],
          [1562, 565],
          [1784, 410],
          [1759, 485],
          [1815, 516]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6709",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.66,
      "hc-middle-y": 0.50,
      "hc-key": "sc-6709",
      "hc-a2": "ER",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549885",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "English River",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4533",
      "woe-name": "English River",
      "latitude": "-4.60746",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1568, 1198],
          [1569, 1113],
          [1557, 988],
          [1433, 960],
          [1447, 1044],
          [1362, 1134],
          [1508, 1209],
          [1568, 1198]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6710",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.56,
      "hc-middle-y": 0.54,
      "hc-key": "sc-6710",
      "hc-a2": "MB",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549887",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Mont Buxton",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4428",
      "woe-name": "Mont Buxton",
      "latitude": "-4.61246",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1362, 1134],
          [1447, 1044],
          [1433, 960],
          [1339, 1021],
          [1310, 1091],
          [1362, 1134]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6712",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.38,
      "hc-middle-y": 0.27,
      "hc-key": "sc-6712",
      "hc-a2": "PL",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549881",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Plaisance",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4693",
      "woe-name": "Plaisance",
      "latitude": "-4.65451",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1759, 485],
          [1784, 410],
          [1562, 565],
          [1618, 678],
          [1646, 734],
          [1696, 809],
          [1738, 755],
          [1731, 673],
          [1741, 617],
          [1722, 594],
          [1759, 485]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6713",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.54,
      "hc-middle-y": 0.79,
      "hc-key": "sc-6713",
      "hc-a2": "PL",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549873",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Pointe La Rue",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.5163",
      "woe-name": "Pointe Larue",
      "latitude": "-4.67403",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2068, 355],
          [2147, 475],
          [2177, 455],
          [2308, 325],
          [2068, 355]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6715",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.42,
      "hc-middle-y": 0.43,
      "hc-key": "sc-6715",
      "hc-a2": "SL",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549886",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Saint Louis",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4388",
      "woe-name": "Saint Louis",
      "latitude": "-4.62247",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1433, 960],
          [1301, 856],
          [1263, 926],
          [1339, 1021],
          [1433, 960]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6716",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.53,
      "hc-middle-y": 0.58,
      "hc-key": "sc-6716",
      "hc-a2": "TA",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549867",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Takamaka",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.5173",
      "woe-name": "Takamaka",
      "latitude": "-4.79065",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2280, -638],
          [2295, -785],
          [2376, -848],
          [2411, -999],
          [2215, -999],
          [2049, -914],
          [1930, -708],
          [2112, -718],
          [2107, -652],
          [2280, -638]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6717",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.35,
      "hc-middle-y": 0.40,
      "hc-key": "sc-6717",
      "hc-a2": "LM",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549880",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Les Mamelles",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4808",
      "woe-name": "Les Mamelles",
      "latitude": "-4.65751",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1887, 556],
          [1815, 516],
          [1759, 485],
          [1722, 594],
          [1741, 617],
          [1731, 673],
          [1887, 556]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6718",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.90,
      "hc-middle-y": 0.79,
      "hc-key": "sc-6718",
      "hc-a2": "RC",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549879",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Roche Caïman",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4828",
      "woe-name": "Roche Caiman",
      "latitude": "-4.6495",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1887, 556],
          [1731, 673],
          [1738, 755],
          [1914, 632],
          [1887, 556]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6694",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.88,
      "hc-middle-y": 0.56,
      "hc-key": "sc-6694",
      "hc-a2": "AA",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549874",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Anse aux Pins",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.5208",
      "woe-name": "Anse aux Pins",
      "latitude": "-4.68304",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2308, 325],
          [2284, 229],
          [2043, 317],
          [2068, 355],
          [2308, 325]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6695",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.22,
      "hc-middle-y": 0.71,
      "hc-key": "sc-6695",
      "hc-a2": "AB",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549869",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Anse Boileau",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4923",
      "woe-name": "Anse Boileau",
      "latitude": "-4.71357",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1912, -278],
          [1841, -182],
          [1790, -117],
          [1805, -27],
          [1765, 43],
          [1794, 142],
          [1911, 236],
          [1949, 349],
          [2003, 331],
          [2039, 49],
          [2087, -100],
          [2056, -306],
          [1912, -278]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6696",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.82,
      "hc-middle-y": 0.45,
      "hc-key": "sc-6696",
      "hc-a2": "AE",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549884",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Anse Etoile",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4543",
      "woe-name": "Anse Etoile",
      "latitude": "-4.58794",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1610, 1489],
          [1646, 1360],
          [1602, 1312],
          [1568, 1198],
          [1508, 1209],
          [1362, 1134],
          [1348, 1228],
          [1362, 1322],
          [1428, 1458],
          [1560, 1435],
          [1610, 1489]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6697",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.57,
      "hc-middle-y": 0.50,
      "hc-key": "sc-6697",
      "hc-a2": "AC",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549872",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Au Cap",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.5138",
      "woe-name": "Au Cap",
      "latitude": "-4.70356",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2043, 317],
          [2284, 229],
          [2233, 29],
          [2273, -36],
          [2304, -282],
          [2106, -158],
          [2087, -100],
          [2039, 49],
          [2003, 331],
          [2043, 317]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6698",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.91,
      "hc-middle-y": 0.34,
      "hc-key": "sc-6698",
      "hc-a2": "AR",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549870",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Anse Royale",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.5118",
      "woe-name": "Anse Royale",
      "latitude": "-4.7456",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2304, -282],
          [2213, -307],
          [2184, -427],
          [2280, -638],
          [2107, -652],
          [2064, -544],
          [2050, -351],
          [2056, -306],
          [2087, -100],
          [2106, -158],
          [2304, -282]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6699",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.48,
      "hc-key": "sc-6699",
      "hc-a2": "BL",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549868",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Baie Lazare",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4918",
      "woe-name": "Baie Lazare",
      "latitude": "-4.75461",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2056, -306],
          [2050, -351],
          [2064, -544],
          [2107, -652],
          [2112, -718],
          [1930, -708],
          [1907, -669],
          [1862, -553],
          [1766, -519],
          [1691, -569],
          [1610, -529],
          [1660, -333],
          [1839, -334],
          [1912, -278],
          [2056, -306]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC.6701",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.41,
      "hc-middle-y": 0.33,
      "hc-key": "sc-6701",
      "hc-a2": "BV",
      "labelrank": "20",
      "hasc": "SC.",
      "alt-name": null,
      "woe-id": "24549877",
      "subregion": null,
      "fips": null,
      "postal-code": null,
      "name": "Beau Vallon",
      "country": "Seychelles",
      "type-en": null,
      "region": null,
      "longitude": "55.4317",
      "woe-name": "Beau Vallon",
      "latitude": "-4.60295",
      "woe-label": null,
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1362, 1322],
          [1348, 1228],
          [1362, 1134],
          [1310, 1091],
          [1339, 1021],
          [1263, 926],
          [1202, 1044],
          [1108, 1011],
          [1079, 1045],
          [1114, 1059],
          [1164, 1145],
          [1205, 1230],
          [1264, 1272],
          [1275, 1322],
          [1362, 1322]
        ]
      ]
    }
  }]
};

export default seychelles;
